import { render } from "./TopNFTs.vue?vue&type=template&id=b7da917e&ts=true"
import script from "./TopNFTs.vue?vue&type=script&lang=ts"
export * from "./TopNFTs.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__